// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__VvU2X","content":"LoadingAlert_content__2UR2r"};